import { faUserDoctor } from "@fortawesome/pro-duotone-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { SxProps, Typography } from "@mui/material"
import React, { ReactNode } from "react"
import { useAccessibility } from "../../../../Store/contexts/AccessibilityContext"
import DefaultText from "../../../../components/Accessibility/DefaultText"
import DefaultTextBold from "../../../../components/Accessibility/DefaultTextBold"
import WhiteContainer from "../../../../components/Accessibility/WhiteContainer"
import { DoctorGC } from "../../../../interfaces/entities/SaudeBemEstar/GestaoDeCronicos/DoctorGC"

const sxStyleTitle: SxProps = {
	fontFamily: "UnimedSans-Bold",
	fontWeight: 700,
	fontSize: "20px",
	lineHeight: "30px",
	letterSpacing: "0em",
	textAlign: "left",
	color: "#383838",
	textWrap: 'wrap',
	'@media(max-width: 799px)': {
		width: '100%'
	},
	marginBottom: '10px'
}

const PrestadorCard: React.FC<{ prestador?: DoctorGC, button: ReactNode, showTitle?: boolean }> = ({ prestador, button, showTitle }) => {

	const accessibility = useAccessibility();
	return (
		<WhiteContainer shadow style={{ width: '100%', padding: '32px' }} className="flex-mobile gap-20 align-start">
			<FontAwesomeIcon icon={faUserDoctor} style={{ ...accessibility.contrastColorAccessibility }} className="fa-icon32x32" />
			<div className="flex-col gap-10 align-start">
				{showTitle && <Typography sx={sxStyleTitle} style={accessibility.textStyleAccessibility} component={'h2'}>Profissional selecionado(a):</Typography>}
				<DefaultTextBold text={prestador?.nome || ''} />
				<DefaultText text={`<b>Tipo:</b> ${prestador?.descrEspec}`} />
				{button}
			</div>
		</WhiteContainer>
	)
}

export default PrestadorCard;